import {
  object, string, boolean, date,
} from 'yup';

const advancedFieldsToCompanySchema = object({
  id: string(),
  created_on: date().default(() => new Date()),
  updated_on: date().required(),

  field_id: string().required(),
  company_id: string().required(),
  is_active: boolean().default(true),
});

export default advancedFieldsToCompanySchema;
